import React, { useCallback } from 'react';
import { css } from 'aphrodite';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import styles from './styles';
import { FolderData } from './types';

export type MatterFolderRowProps = {
  folder: FolderData;
  selectedId: number | null;
  onRowClick: (folder: FolderData) => void;
  onExpandToggle: () => void;
  isExpanded: boolean;
  isLoading?: boolean;
};

const MatterFolderRow = ({
  folder,
  selectedId,
  onRowClick,
  onExpandToggle,
  isExpanded,
  isLoading = false,
}: MatterFolderRowProps) => {
  const isSelected = selectedId === folder.id;

  const handleRowClick = useCallback(() => {
    onRowClick(folder);
  }, [folder, onRowClick]);

  const handleToggleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      onExpandToggle();
    },
    [onExpandToggle],
  );

  return (
    <div
      className={css(
        styles.tableRow,
        isSelected && styles.tableRowSelected,
        styles.matterFolderRow,
      )}
      onClick={handleRowClick}
      role="row"
      tabIndex={0}
      aria-selected={isSelected}
      aria-expanded={isExpanded}
    >
      <div className={css(styles.matterFolderExpandColumn)}>
        <button
          onClick={handleToggleClick}
          className={css(styles.expandButton)}
          aria-label={`${isExpanded ? 'Collapse' : 'Expand'} ${
            folder.name
          } folder`}
          disabled={isLoading}
        >
          <ChevronRightIcon
            style={{
              fontSize: 16,
              color: isLoading ? '#ccc' : '#666',
              transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s ease-in-out',
            }}
          />
        </button>
      </div>

      <div className={css(styles.matterFolderIconColumn)}>
        <FolderOutlinedIcon className={css(styles.folderIcon)} />
      </div>

      <div className={css(styles.matterFolderNameColumn)}>
        <span className={css(styles.folderName)}>{folder.name}</span>
        {isSelected && (
          <span
            className={css(
              styles.currentFolderChip,
              styles.matterFolderChipSpacing,
            )}
          >
            Current folder
          </span>
        )}
      </div>
    </div>
  );
};

export default MatterFolderRow;
